import React from 'react';
import GiftPage from '@/components/Pages/GiftPage.web';

export default function GiftSettings() { return <GiftPage purchase />; }
